// extracted by mini-css-extract-plugin
export default {"description":"style_description__PDZRi","fade-in":"style_fade-in__O0ogv","top":"style_top__ebBPV","image":"style_image__z2I+3"};